const BRadio = ({ id, value, label, ...props }) => {
  return (
    <div className="inline-flex items-center gap-1">
      <label className="relative flex cursor-pointer items-center" htmlFor="html">
        <input
          {...props}
          type="radio"
          value={value}
          className="size-4 cursor-pointer rounded-full transition-all"
          id={id}
        />
      </label>
      <label htmlFor={id} className="text-sm leading-none font-normal text-slate-700 first-letter:capitalize">
        {label}
      </label>
    </div>
  );
};

export default BRadio;
